/**
 * Feature flags for the site.
 *
 * Set a flag to `true` to enable, `false` to disable.
 * When disabled, all UI, routes, sitemap entries, SEO mentions and FAQ
 * entries related to that feature are hidden.
 */

export const FEATURE_ACCOMPAGNEMENT = false;
export const FEATURE_CORRESPONDANCE = false;
